import BaseMutations from '@/store/base/mutations'

// const module = 'employeeWorkTripMails'

export default BaseMutations({

})
